import React from 'react'
import { Link } from 'react-router-dom'
import { PlusIcon } from '@heroicons/react/outline'

const ContentAddButton = () => {
  return (
    <Link to="/contents/add" className="flex items-center justify-center gap-3 px-5 py-3 text-white bg-blue-600 rounded-lg shadow hover:bg-blue-700 shadow-blue-100">
        <PlusIcon className="w-5 h-5" />
        <span>Tambah Konten</span>
    </Link>
  )
}

export default ContentAddButton